module.exports = __webpack_public_path__ + "img/res_lovo.png";